import { render, staticRenderFns } from "./DomainTagInput.vue?vue&type=template&id=45831b03&scoped=true"
import script from "./DomainTagInput.vue?vue&type=script&lang=js"
export * from "./DomainTagInput.vue?vue&type=script&lang=js"
import style0 from "./DomainTagInput.vue?vue&type=style&index=0&id=45831b03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45831b03",
  null
  
)

export default component.exports